import './news-date.scss';

/**
 * version    1.0
 * class      <type> (News Date)
 * classdesc  Component that contains the logic for the article detail page
 */
export class NewsDate {}
